import * as Sentry from "@sentry/react";

// Works on both client and server — capture functions dispatch to whichever
// transport was initialized (browser via instrumentation-client.ts, Node via
// instrumentation.ts).
export const getInstance = (): typeof Sentry => Sentry;
